import {asyncRouterMap, constantRouterMap} from '@/router'

export function hasPermission(userRoles, route) {
  if (!route.meta || route.meta.onlyAuthenticated || !route.meta.roles) return true
  return userRoles.some(userRole => route.meta.roles.some(routeRole => routeRole === userRole))
}

function filterAsyncRouter(asyncRouterMap, roles) {
  return asyncRouterMap.filter(route => {
    if (!hasPermission(roles, route)) return false
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, roles)
    }
    return true
  })
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({commit}, data) {
      return new Promise(resolve => {
        const {roles} = data
        let accessedRouters
        if (roles.indexOf('ROLE_ADMIN') >= 0 || roles.indexOf('ROLE_WAITER') >= 0) {
          accessedRouters = asyncRouterMap
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js